import { logError } from "services/logging";
import * as ConversationEvents from "./conversation";
import * as ResponseEvents from "./response";
import * as SessionEvents from "./session";

// Partial list of events available in the Realtime API

export type RealtimeServerEvent =
  | SessionEvents.ServerSessionEvent
  | ResponseEvents.ServerResponseEvent
  | ConversationEvents.ServerConversationEvent
  | { type: string }; // Fallback for untyped events

export type RealtimeClientEvent =
  | SessionEvents.ClientSessionEvent
  | ConversationEvents.ClientConversationEvent
  | ResponseEvents.ResponseClientEvent
  | ClearInputAudioBufferEvent
  | ClearOutputAudioBufferEvent
  | { type: string }; // Fallback for untyped events;

export type ClearInputAudioBufferEvent = {
  type: "input_audio_buffer.clear";
};

export type ClearOutputAudioBufferEvent = {
  type: "output_audio_buffer.clear";
};

export * from "./session";
export * from "./response";
export * from "./conversation";

export type EventOfType<T extends RealtimeServerEvent["type"]> = Extract<
  RealtimeServerEvent,
  { type: T }
>;

export const parseServerEventData = (event: MessageEvent): RealtimeServerEvent => {
  try {
    return JSON.parse(event.data) as RealtimeServerEvent;
  } catch (error) {
    logError("Error parsing server event data:", { error, data: event.data });
    throw error;
  }
};
